import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoKey, setVideoKey] = useState(0); // Key to force video reload

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      if (mobile !== isMobile) {
        setIsMobile(mobile);
        setVideoKey((prevKey) => prevKey + 1); // Change key to force video reload
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Video background with placeholder image */}
      <div className="absolute inset-0 z-0">
        {!videoLoaded && (
          <img
            src="/assets/images/hero_placeholder.jpg"
            alt="Hero Placeholder"
            className="w-full h-full object-cover"
          />
        )}
        <video
          key={videoKey} // Force re-render when key changes
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
          style={{
            transform: 'scale(1.00)',
          }}
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source
            src={
              isMobile
                ? '/assets/videos/hero_section_small.webm'
                : '/assets/videos/hero_section.webm'
            }
            type="video/webm"
          />
          <source
            src={
              isMobile
                ? '/assets/videos/hero_section_small.mp4'
                : '/assets/videos/hero_section.mp4'
            }
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col items-center text-center">
          <div className="mb-10 w-full md:w-3/5">
            <h1 className="text-xl font-bold text-white mb-6">
              {t('home.heroTitle')}
            </h1>
            <p className="text-3xl md:text-5xl font-bold text-white mb-8">
              {t('home.heroSubtitle')}
            </p>
            <p className="md:text-2xl text-gray-200 mb-8">
              {t('home.heroSubtitle2')}
            </p>

            {/* Button container with proper spacing and alignment */}
            <div className="flex flex-col md:flex-row w-full gap-6 justify-center">
              <a
                href="/services"
                target="_self"
                className="bg-gradient-to-r from-blue-600/80 to-sky-600/80 hover:from-blue-700 hover:to-sky-700 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                {t('home.ctaPrimary')}
              </a>

              <a
                href="https://wa.me/971503534324"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-transparent hover:bg-white/10 text-white font-bold py-3 px-8 rounded-lg border-2 border-white transition-all duration-300 transform hover:scale-105"
              >
                {t('home.ctaSecondary')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
